(function () {
  function setBoolAttr(el, name, on) {
    if (!el) return;
    if (on) el.setAttribute(name, "");
    else el.removeAttribute(name);
  }

  function onChipClick(e) {
    const chipBtn = e.target.closest(".product-chips-options__item button");
    if (!chipBtn) return;

    const card = chipBtn.closest(".product-item");
    if (!card) return;

    const variantId = chipBtn.getAttribute("data-variant-id");
    const priceText = chipBtn.getAttribute("data-variant-price");
    const url = chipBtn.getAttribute("data-variant-url");
    const available = chipBtn.getAttribute("data-variant-available") === "true";

    // 1) Update hidden variant input (so quick-add adds the RIGHT variant)
    const variantInput = card.querySelector('input[data-pa-variant-input][name="id"]');
    if (variantInput && variantId) variantInput.value = variantId;

    // 2) Update the price shown beneath the product title (it no longer lives in the CTA)
    const comparePrice = chipBtn.getAttribute("data-variant-compare-price");
    const priceEl = card.querySelector("[data-pa-card-price]");
    const compareEl = card.querySelector("[data-pa-card-compare]");

    if (priceEl) {
      if (priceText) priceEl.textContent = priceText;
      // Only a discounted variant gets the "sale" styling
      priceEl.classList.toggle("sale", !!comparePrice);
    }

    if (compareEl) {
      compareEl.textContent = comparePrice || "";
      setBoolAttr(compareEl, "hidden", !comparePrice);
    }

    // 3) Update button state + text (price is no longer rendered inside the button,
    //    which keeps every CTA the same size)
    const btn = card.querySelector("[data-pa-atc]");
    if (btn) {
      const atcTextEl = btn.querySelector("[data-pa-atc-text]") || btn.querySelector(".prod-atc");

      const soldText = btn.getAttribute("data-pa-soldout-text") || "Out of stock";
      const addText = btn.getAttribute("data-pa-add-text") || "Add to Bag";

      if (available) {
        btn.classList.remove("is-sold-out");
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");

        if (atcTextEl) atcTextEl.textContent = addText;
      } else {
        btn.classList.add("is-sold-out");
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");

        if (atcTextEl) atcTextEl.textContent = soldText;
      }

      // Keep data-product-id correct if your theme reads it
      if (variantId) btn.setAttribute("data-product-id", variantId);
    }

    // 4) Toggle sold out badge on the card
    const soldBadge = card.querySelector("[data-pa-soldout-badge]");
    if (soldBadge) {
      if (available) soldBadge.setAttribute("hidden", "");
      else soldBadge.removeAttribute("hidden");
    }

    // 5) Update links to selected variant (optional but nice)
    if (url) {
      const link1 = card.querySelector(".product-item__image-link");
      const link2 = card.querySelector(".product-item__product-title a");
      if (link1) link1.href = url;
      if (link2) link2.href = url;
    }
  }

  document.addEventListener("click", onChipClick);

  // --- Mobile size dropdown -------------------------------------------------
  // Below 960px the chip list is hidden and a <select> is shown in its place
  // (snippets/product-item-chips.liquid). The select does not update the card
  // itself — it clicks the matching chip button, so onChipClick above AND the
  // duplicate chip handler appended to assets/theme.min.js both run exactly as
  // they do on desktop. One code path, no divergence.
  document.addEventListener("change", function (e) {
    const select = e.target.closest ? e.target.closest("[data-pa-chip-select]") : null;
    if (!select) return;

    const card = select.closest(".product-item");
    if (!card) return;

    const chipBtn = card.querySelector(
      '.product-chips-options__item button[data-variant-id="' + select.value + '"]'
    );
    if (chipBtn) chipBtn.click();
  });

  // Keep the select in step when the selection changes some other way (a chip
  // tapped on a wide screen, or the theme.min.js handler acting on its own).
  document.addEventListener("click", function (e) {
    const chipBtn = e.target.closest
      ? e.target.closest(".product-chips-options__item button")
      : null;
    if (!chipBtn) return;

    const card = chipBtn.closest(".product-item");
    if (!card) return;

    const select = card.querySelector("[data-pa-chip-select]");
    const variantId = chipBtn.getAttribute("data-variant-id");
    if (select && variantId && select.value !== variantId) select.value = variantId;
  });

  // --- Card photo scroll dots ----------------------------------------------
  // The two card photos are a scroll-snap carousel on touch devices. Move
  // .is-active so the dots reflect which photo is showing.
  function syncDots(link) {
    const media = link.closest(".product-item__media");
    if (!media) return;
    const dots = media.querySelectorAll("[data-pa-card-dots] .product-item__dot");
    if (dots.length < 2) return;

    const width = link.clientWidth || 1;
    const index = Math.min(dots.length - 1, Math.round(link.scrollLeft / width));
    for (let i = 0; i < dots.length; i++) dots[i].classList.toggle("is-active", i === index);
  }

  document.addEventListener(
    "scroll",
    function (e) {
      const link = e.target.closest
        ? e.target.closest(".product-item__image-link")
        : null;
      if (link) syncDots(link);
    },
    true // scroll doesn't bubble — capture it
  );
})();